import classnames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { ForwardRefRenderFunction, Fragment, ReactElement } from 'react';
import * as React from 'react';
import { TextLink } from 'palette/TextLink';
import { Typography } from 'palette/Typography';

interface IBreadcrumbItemProps {
    items: Array<BreadcrumbItemProps>;
    item: BreadcrumbItemProps;
    onClick: React.MouseEventHandler<HTMLAnchorElement>;
    onContextMenu: React.MouseEventHandler<HTMLAnchorElement>;
}

interface BreadcrumbItemProps {
    text: string;
    type: 'link' | 'text';
    href: string;
    className: string;
}

const BreadcrumbItem = React.forwardRef(
    ({
        items,
        item,
        onClick,
        onContextMenu,
    }: IBreadcrumbItemProps, ref: React.Ref<HTMLLIElement>): ReactElement | null => {
        const [, BEMElement] = BEMBlock('palette-breadcrumb');
        return (
            <Fragment key={Math.random()}>
                <li
                    ref={ref}
                    aria-current={items.indexOf(item) === items.length - 1 ? 'page' : undefined}
                    className={BEMElement('item')}
                    id={item?.text}
                >
                    {item?.type === 'link' ? (
                        <TextLink
                            className={classnames(
                                BEMElement('link'),
                                item?.className,
                            )}
                            href={item?.href}
                            onClick={onClick}
                            onContextMenu={onContextMenu}
                        >
                            {item?.text}
                        </TextLink>
                    ) : (
                        <Typography
                            className={classnames(
                                BEMElement('text'),
                                item?.className,
                            )}
                        >
                            {item?.text}
                        </Typography>
                    )}
                </li>
            </Fragment>
        );
    },
);

BreadcrumbItem.displayName = 'BreadcrumbItem';

export default BreadcrumbItem as ForwardRefRenderFunction<React.Ref<HTMLLIElement>, IBreadcrumbItemProps>;
